import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

//actions
import {
    changeLayout,
    changeTopbarTheme,
    changeLayoutWidth,
    showRightSidebarAction,
    getUserMenu,
    getAppInfo,
} from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

//components
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";
import { getUserProfileInfo } from "../../store/auth/profile/actions"
import useNotificationPolling from "../../hooks/useNotificationPolling";
import useUserActivity from "../../hooks/useUserActivity";
import useTokenRefresh from "../../hooks/useTokenRefresh";
import useSessionConfig from "../../hooks/useSessionConfig";

const Layout = (props) => {

    const dispatch = useDispatch();

    const {
        topbarTheme, layoutWidth, isPreloader, showRightSidebar, appInfo, userMenu
    } = useSelector(state => ({
        topbarTheme: state.Layout.topbarTheme,
        layoutWidth: state.Layout.layoutWidth,
        isPreloader: state.Layout.isPreloader,
        showRightSidebar: state.Layout.showRightSidebar,
        appInfo: state.appInfo.appInfo,
        userMenu: state.userMenu.userMenu,
    }));

    /*
    document title
    */
    useEffect(() => {
        const title = props.location.pathname;
        let currentage = title.charAt(1).toUpperCase() + title.slice(2);

        document.title =
            currentage + " | Content Management System (JVP)";
    }, [props.location.pathname]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.location.pathname]);

    // Initialize notification polling
    useNotificationPolling(180000) // Poll every 120 seconds
    
    // Initialize session configuration from appInfo
    useSessionConfig()
    
    // Initialize user activity tracking and token refresh
    useUserActivity()
    useTokenRefresh()


    //hides right sidebar on body click
    const hideRightbar = (event) => {
        var rightbar = document.getElementById("right-bar");
        //if clicked in inside right bar, then do nothing
        if (rightbar && rightbar.contains(event.target)) {
            return;
        } else {
            //if clicked in outside of rightbar then fire action for hide rightbar
            dispatch(showRightSidebarAction(false));
        }
    };

    /*
    layout settings
    */
    useEffect(() => {
        dispatch(changeLayout("horizontal"));
    }, [dispatch]);

    useEffect(() => {
        //init body click event fot toggle rightbar
        document.body.addEventListener("click", hideRightbar, true);

        let timeoutId
        if (isPreloader === true) {
            document.getElementById("preloader").style.display = "block";
            document.getElementById("status").style.display = "block";

            timeoutId = setTimeout(function () {
                document.getElementById("preloader").style.display = "none";
                document.getElementById("status").style.display = "none";
            }, 2500);
        } else {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
        }

        return () => {
            document.body.removeEventListener("click", hideRightbar, true);
            if (timeoutId) clearTimeout(timeoutId);
        }
    }, [isPreloader]);

    useEffect(() => {
        if (topbarTheme) {
            dispatch(changeTopbarTheme(topbarTheme));
        }
    }, [dispatch, topbarTheme]);

    useEffect(() => {
        if (layoutWidth) {
            dispatch(changeLayoutWidth(layoutWidth));
        }
    }, [dispatch, layoutWidth]);

    useEffect(() => {
        dispatch(
            getAppInfo()
            // { encDecAlgo: "BASE64" }
        )
        dispatch(getUserMenu()
            // { encDecAlgo: "BASE64" }
        )
        dispatch(getUserProfileInfo())
    }, [])

    const [isMenuOpened, setIsMenuOpened] = useState(false);
    const openMenu = () => {
        setIsMenuOpened(!isMenuOpened);
    };

    return (
        <React.Fragment>
            <div id="preloader">
                <div id="status">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <div id="layout-wrapper">
                <Header
                    theme={topbarTheme}
                    isMenuOpened={isMenuOpened}
                    openLeftMenuCallBack={openMenu}
                />
                <Navbar menuOpen={isMenuOpened} appInfo={appInfo} userMenu={userMenu} />
                <div className="main-content">{props.children}</div>
                <Footer />
            </div>

            {showRightSidebar ? <RightSidebar /> : null}
        </React.Fragment>
    );
};

Layout.propTypes = {
    changeLayout: PropTypes.func,/*  */
    changeLayoutWidth: PropTypes.func,
    changeTopbarTheme: PropTypes.func,
    children: PropTypes.object,
    isPreloader: PropTypes.any,
    layoutWidth: PropTypes.any,
    location: PropTypes.object,
    showRightSidebar: PropTypes.any,
    topbarTheme: PropTypes.any
};

export default withRouter(Layout);